module.exports = __webpack_public_path__ + "media/images/sp/plans/inclusion_13-49fff2475c3af04a4a580cb799214f49.png";